import { z } from 'zod'
import { t } from 'i18next'

// Default constants
const DEFAULT_AUFTRAG_29_10 = {
  enabled: false
}

const DEFAULT_AUFTRAG_29_20 = {
  enabled: false
}

const DEFAULT_AUFTRAG_29_30 = {
  enabled: false
}

const DEFAULT_BEFEHL_29_FORM = {
  auftrag_29_10: DEFAULT_AUFTRAG_29_10,
  auftrag_29_20: DEFAULT_AUFTRAG_29_20,
  auftrag_29_30: DEFAULT_AUFTRAG_29_30
}

// Schema definitions
const Auftrag29_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_29_10.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_29_10))

const Auftrag29_20Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_29_20.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_29_20))

const Auftrag29_30Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_29_30.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_29_30))

// Base schema
const Befehl29FormSchemaBase = z
  .object({
    auftrag_29_10: Auftrag29_10Schema,
    auftrag_29_20: Auftrag29_20Schema,
    auftrag_29_30: Auftrag29_30Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_29_FORM))

export const Befehl29FormSchema = Befehl29FormSchemaBase

// Validation schema
export const createBefehl29FormValidationSchema = () => {
  return Befehl29FormSchemaBase.refine(
    (data) => {
      return (
        data.auftrag_29_10.enabled ||
        data.auftrag_29_20.enabled ||
        data.auftrag_29_30.enabled
      )
    },
    {
      message: t('ui-validation:befehl29.at_least_one')
    }
  )
}

export type Befehl29FormData = z.infer<typeof Befehl29FormSchemaBase>
